<template>
  <div>
    <div class="brand-logo">
      <BrandLogo
        name="Stage Performing Art"
        :logo="require('../../../assets/brands_logo_4_big.png')"
        desc="Shenzhen CC Orange Co., Ltd."
      ></BrandLogo>
    </div>
    <BrandIntro class="brand-intro" :lineArray="array"></BrandIntro>
    <div class="products">
      <div class="products__block">
        <div class="products__block__title">Performance</div>
        <img
          class="products__block__img"
          src="../../../assets/brands_image_6.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BrandLogo from "./BrandLogo";
import BrandIntro from "./BrandIntro"
export default {
  data() {
    return {
      array: [
        "Three Annual Art Festivals: Urban Drama Festival, AC Orange Art Festival and New Wave Chinese Opera Festival",
        "Professional programming, marketing and operation expertise for more than 100 theaters",
        "Chinese Opera official social media, trusted by 350,000 followers.",
        "Artists Dream Project, aiming to discover and support 100 artists and groups to tour 1000 performances",
      ]
    };
  },
  components: {
    BrandLogo,
    BrandIntro
  }
};
</script>
<style lang="scss" scoped>
.brand-logo {
  padding: 64px 0 54px 0;
  text-align: center;
}
.brand-intro{
  width: 1200px;
  margin: 0 auto;
}
.products {
  height: 705px;
  background-color: #1f1f1f;
  overflow: hidden;
  &__block {
    &__title {
      color: #ec6900;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-size: 26px;
      margin-top: 58px;
    }
    &__img {
      display: block;
      margin: 31px auto 0 auto;
    }
  }
}
</style>